import { HttpEventType } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { base64ToFile, ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { ToastrService } from 'ngx-toastr';
import { MembersService } from '../members.service';

interface Data {
  id: number;
}

@Component({
  selector: 'app-members-file-send',
  templateUrl: './members-file-send.component.html',
  styleUrls: ['./members-file-send.component.css'],
})
export class MembersGetFile implements OnInit {
  imageChangedEvent: any = '';
  croppedImage: any = '';
  uploadProgress: number;

  id: number;

  constructor(public dialog: MatDialogRef<MembersGetFile>) {}

  ngOnInit(): void {}

  sendFile() {
    const originalFile: File = this.imageChangedEvent.target.files[0];
    const blob = this.base64ToFileLOcal(this.croppedImage, originalFile.name);
    console.log('file size', this.formatBytes(originalFile.size));

    const data = {
      blob,
      originalFileName: originalFile.name,
      originalFile,
    };
    this.dialog.close(data);
  }

  // image cropper functions
  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  base64ToFileLOcal(dataurl: string, filename: string = 'image.png') {
    if (!dataurl) return null;

    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  formatBytes(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
}
